import React from 'react'

export interface SelectedCity {
    id: number
    name: string
    latitude: number
    longitude: number
    countryId?: number | null
    countryName?: string | null
}

interface CityContextValue {
    selectedCity: SelectedCity | null
    setSelectedCity: (city: SelectedCity | null) => void
}

const STORAGE_KEY = 'taxikids_city'

export const CityContext = React.createContext<CityContextValue>(null!)

export const CityProvider: React.FC<{ children: React.ReactNode }> = ({
    children
}) => {
    const [selectedCity, setSelectedCityState] =
        React.useState<SelectedCity | null>(null)

    React.useEffect(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY)
            if (raw) {
                setSelectedCityState(JSON.parse(raw) as SelectedCity)
            }
        } catch (e) {
            // ignore corrupt/inaccessible storage
        }
    }, [])

    const setSelectedCity = React.useCallback((city: SelectedCity | null) => {
        setSelectedCityState(city)
        try {
            if (city) {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(city))
            } else {
                localStorage.removeItem(STORAGE_KEY)
            }
        } catch (e) {
            // ignore quota/security errors
        }
    }, [])

    return (
        <CityContext.Provider value={{ selectedCity, setSelectedCity }}>
            {children}
        </CityContext.Provider>
    )
}

export function useCity(): CityContextValue {
    return React.useContext(CityContext)
}
